"use client";

import { MdOutlineFaceUnlock } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

export default function ApplicationLogTable({ applications }) {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  const isAgent = pathname.includes("/agent/");
  const mapStatusForAgent = (status) => {
    if (!isAgent) return status;
    if (status === "WithdrawnByClient" || status === "WithdrawnByAgent") return "Withdrawn";
    return status;
  };

  return (
    <div className="w-full">
      <div className="overflow-x-auto">
        <table className="w-full text-nowrap">
          <thead>
            <tr className="text-left font-normal">
              <th
                onClick={() => console.log(applications)}
                className="p-4 font-normal"
              >
                Name
              </th>
              <th className="p-4 font-normal">Date</th>
              <th className="p-4 font-normal">Country</th>
              <th className="p-4 font-normal">Type</th>
              <th className="p-4 font-normal">Agent</th>
              <th className="p-4 font-normal">Current Status:</th>
            </tr>
          </thead>
          <tbody>
            {applications?.map((row, index) => (
              <tr
                key={index}
                className={`text-white ${index % 2 === 0 ? "bg-[#005787]" : "bg-[#036494]"
                  }`}
              >
                <td
                  onClick={() => {
                    if (pathname.includes("admin")) {
                      navigate(`/admin/application-log/${row._id}`);
                    } else if (pathname.includes("agent")) {
                      navigate(`/agent/application-log/${row._id}`);
                    }
                  }}
                  className="p-4 cursor-pointer"
                >
                  <div className="flex items-center gap-3">
                    <div className="p-1 bg-white rounded-full flex items-center justify-center text-black">
                      <MdOutlineFaceUnlock size={32} />
                    </div>
                    <div>
                      <div className="font-medium">
                        {row?.firstName + " " + row?.lastName}
                      </div>
                      <div className="text-sm opacity-75">{row?.uniqueId}</div>
                    </div>
                  </div>
                </td>
                <td className="p-4">
                  {moment(row.createdAt).format("DD/MM/YY")}
                </td>
                <td className="p-4">{row?.countryOfInterest}</td>
                <td className="p-4">
                  <div className="bg-white text-[#0c4a6e] px-4 py-1.5 w-full flex justify-between rounded-full text-sm items-center gap-2">
                    <p>{row?.visaCategory}</p>
                    <span className="text-xs"></span>
                  </div>
                </td>
                <td className="p-4">
                  <div className="bg-white text-[#0c4a6e] px-4 py-1.5 rounded-full text-sm">{`${row.agent
                    ? `${row?.agent?.firstName} ${row?.agent?.lastName}`
                    : "Un-assigned"
                    }`}</div>
                </td>
                <td className="p-4">
                  <div className="flex flex-col gap-1">
                    <div
                      className={`inline-flex items-center gap-1 bg-white w-max px-4 py-0.5 rounded-full text-[#0c4a6e]`}
                    >
                      {row.status === "Draft"
                        ? "Pending for submission"
                        : row.status === "Submitted"
                          ? "Submitted by client"
                          : row.status === "WithdrawnByClient" || row.status === "Cancelled"
                            ? "Cancelled"
                            : row.status === "WithdrawnByAgent"
                              ? "Withdrawn"
                              : row.status === "VisaApplied"
                                ? "Visa Applied"
                              : mapStatusForAgent(row.status)}
                      <span className="text-xs ml-4"></span>
                    </div>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
